import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  csvHistoryAccessControl,
  shiftsAccessControl,
} from '../access-control/shiftsAccess.configuration'

const ShiftManagementPage = lazy(
  () =>
    /* webpackChunkName: "ShiftManagementPage" */
    import('../pages/ShiftManagement/page')
)
const CsvHistoryRoute = lazy(
  () =>
    /* webpackChunkName: "CsvHistoryRoute" */
    import('./csvHistoryRoute')
)
// @hygen:inject page-import

/**
 * Retailer-scoped (legacy) Shifts.
 *
 * The wrapper carries no access control: `csvHistory` owns its own gate (so its redirect can
 * run past the r2026_11_0 cutoff) and `shifts` keeps the closing one. Both are exact, so
 * neither URL changed when `csvHistory` stopped nesting under the shifts gate.
 */
export const shiftsRouter = (
  <DomainRoute route="shifts">
    <DashSwitch>
      <DomainRoute
        exact
        route="csvHistory"
        accessControl={csvHistoryAccessControl}
        component={CsvHistoryRoute}
      />
      <DomainRoute
        exact
        route="shifts"
        accessControl={shiftsAccessControl}
        component={ShiftManagementPage}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
